<template>
  <v-row 
    class="d-flex justify-space-between" 
    style="height: 1px; position: sticky; top: 0; z-index: 9999;"
  >
    <v-col
      v-for="color in colorBanner" 
      :key="color"
      class="pa-0 ma-0"
      :style="{ backgroundColor: color, height: '6px' }"
    ></v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'Banner',
    data () {
      return {
        colorBanner: [
          "#3C0D44", "#EC5555", "#F2D9DC", 
          "#491057", "#F56B68", "#35103D", "#E6504E"
        ],
      }
    }
  }
</script>
